/* eslint-disable global-require */
const { BASE_CONFIG } = require('./base');
const { ENV_META } = require('./environments');
const { deriveHosts, getSearchApiHost } = require('./deriveHosts');
const { deriveFeatureKeys, deriveFlags } = require('./deriveFeatures');

const rootDomain = 'utrsports.net';
const brandedDomain = 'utrsports.net';
const twitterHandle = 'UTR_Sports_';
const defaultTitle = 'Tennis & Pickleball Ratings & Events | UTR Sports';

const messaging = {
    pollingIntervalMin: 20000,
    pollingIntervalMax: 100000,
};

const messagingProd = {
    pollingIntervalMin: 60000,
    pollingIntervalMax: 180000,
};

const configSource = (process.env.CONFIG_SOURCE || 'local').toLowerCase();
const meta = ENV_META[configSource] || ENV_META.local;

let localConfig = {};
if (meta.type === 'local') {
    try {
        // eslint-disable-next-line
        localConfig = require('../config-local.js').default;
    } catch (e) {
        const isMissingLocalConfig = e.code === 'MODULE_NOT_FOUND' && e.message.includes('config-local.js');
        if (!isMissingLocalConfig) {
            throw e;
        }
    }
}

function pickKnownConfigKeys(overrides = {}) {
    return Object.keys(overrides).reduce((accumulator, key) => {
        if (Object.prototype.hasOwnProperty.call(BASE_CONFIG, key)) {
            accumulator[key] = overrides[key];
        }
        return accumulator;
    }, {});
}

function deriveCoreFields(meta) {
    return {
        siteBaseUrl: process.env.siteBaseUrl || rootDomain,
        brandedUrl: process.env.brandedUrl || brandedDomain,
        twitterAccount: process.env.twitterAccount || twitterHandle,
        defaultTitle,
        googleApiKey: process.env.GOOGLE_API_KEY || '',
        utrStripeAccountId: process.env.UTR_STRIPE_ACCOUNT_ID || '',
        freshChatToken: process.env.FRESHCHAT_TOKEN || '',
        messaging: meta.type === 'prod' ? (process.env.MESSAGING || messagingProd) : messaging,
    };
}

function buildConfig(meta) {
    const localOverrides = meta.type === 'local' ? pickKnownConfigKeys(localConfig) : {};

    return {
        ...BASE_CONFIG,
        ...deriveCoreFields(meta),
        ...deriveHosts(meta),
        ...deriveFeatureKeys(meta),
        ...deriveFlags(meta),
        ...localOverrides,
    };
}

function validate(config) {
    Object.keys(BASE_CONFIG).forEach((key) => {
        if (!Object.prototype.hasOwnProperty.call(config, key)) {
            throw new Error(`Missing config key: ${key}`);
        }
    });
}

const config = buildConfig(meta);

const keySets = Object.keys(ENV_META).map(name => Object.keys(buildConfig(ENV_META[name])).sort((a, b) => a.localeCompare(b)).join(','));
const allEqual = keySets.every(keySet => keySet === keySets[0]);
if (!allEqual) {
    throw new Error('Config shape mismatch between environments');
}

validate(config);

const REQUIRED_IN_NON_LOCAL = [
    'brazeApiKey',
    'segmentKey',
    'statsigKey',
    'stripeKey',
    'stripeClientId',
    'utrStripeAccountId',
    'googleApiKey',
];

if (meta.type !== 'local') {
    REQUIRED_IN_NON_LOCAL.forEach((key) => {
        if (!config[key]) {
            console.warn(`[config] Missing required env var for key: ${key} (CONFIG_SOURCE=${configSource})`);
        }
    });
}

if (process.env.DEBUG_CONFIG === 'true') {
    console.log('CONFIG KEYS:', Object.keys(config).sort((a, b) => a.localeCompare(b)));
}

module.exports = config;
module.exports._getSearchApiHost = getSearchApiHost;
